import BBNavigationMenuMobile from './BBNavigationMenuMobile.component';
export default BBNavigationMenuMobile;